export var LineWeight;
(function (LineWeight) {
    LineWeight[LineWeight["Light"] = 0] = "Light";
    LineWeight[LineWeight["Medium"] = 1] = "Medium";
    LineWeight[LineWeight["Heavy"] = 2] = "Heavy";
})(LineWeight || (LineWeight = {}));
;
